import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useTemuShop } from '@/temu-platform/context/TemuShopContext';
import { temuShopCapabilities } from '@/temu-platform/utils/temuShopCapabilities';

/**
 * 价格处理路由壳：侧栏二级菜单「核价单 / 调价单」。
 */
export default function DiscussHubPage() {
  const location = useLocation();
  const { activeShop } = useTemuShop();
  const caps = temuShopCapabilities(activeShop);
  const canDiscuss = Boolean(caps.canDiscussCost);
  const atRoot = /\/discuss\/?$/.test(location.pathname);

  if (atRoot) {
    return <Navigate to={canDiscuss ? 'cost' : 'rrp'} replace />;
  }

  return <Outlet />;
}
